import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InstagramUserHashtags.graphql';
import { Query, QueryinstagramUserHashtagsArgs } from '../../__generated__/globalTypes';

export const useInstagramUserHashtagsQuery = (options?: QueryHookOptions<Query, QueryinstagramUserHashtagsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinstagramUserHashtagsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInstagramUserHashtagsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinstagramUserHashtagsArgs>
): QueryResult<Query, QueryinstagramUserHashtagsArgs> & {
  getInstagramUserHashtags: LazyQueryExecFunction<Query, QueryinstagramUserHashtagsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInstagramUserHashtags, result] = useLazyQuery<Query, QueryinstagramUserHashtagsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInstagramUserHashtags, ...result };
};

export const useInstagramUserHashtagsPromiseQuery = () => {
  const client = useApolloClient();

  const getInstagramUserHashtags = useCallback(
    (options?: Omit<QueryOptions<QueryinstagramUserHashtagsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinstagramUserHashtagsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInstagramUserHashtags };
};
// Suspense Query Hooks
export const useInstagramUserHashtagsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinstagramUserHashtagsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinstagramUserHashtagsArgs>(QUERY, {
    ...options
  });

  return result;
};
